import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Check = function Check(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "16",
      height: "16",
      rx: "8",
      fill: "#63FB97"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.6666 6L6.99992 9.66667L5.33325 8",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};